import React, {useEffect} from 'react';
import classnames from 'classnames';
import {DatePicker} from 'antd';
import dayjs from 'dayjs';
import 'dayjs/locale/he';
import locale from 'antd/es/date-picker/locale/he_IL';
import {FormattedMessage} from "react-intl";
import DataItemTextarea from '../../../_common/components/DataItemTextarea';
import DataItem from '../../../_common/components/DataItem';
import {integerValue} from '../../../../../utils';
import {Validation} from '../../../../../utils';
import styles from './styles.module.scss';

const GeneralDetailsUnit = ({values, setFieldValue, viewMode, setValid}) => {

  useEffect(() => {
    const isValid = Validation.canSendInvoiceOrderToRivhit(values.createdAt?.toDate());
    setValid(isValid);
  }, [values.createdAt?.toDate()]);

  const prefix = 'invoice-orders-popup-edit';

  return (
    <div className={styles.generalDetails}>
      <div className={styles.generalDetailsItem}>
        <div className={styles.label}>
          <FormattedMessage id={`${prefix}-createdAt`} defaultMessage="Created at"/>
        </div>
        <div className={classnames(styles.field, 'mb-1')}>
          <DatePicker
            value={dayjs(values.createdAt)}
            className="form-control custom-data-item d-flex"
            placeholder={''}
            onChange={(date) => {
              setFieldValue(
                'invoiceOrderData.createdAt',
                dayjs(date)
              );
            }}
            locale={locale}
            format={'DD-MM-YYYY'}
            suffixIcon={false}
            clearIcon={false}
            showToday={false}
            disabled={viewMode}
          />
        </div>
      </div>
      <div className={styles.generalDetailsItem}>
        <div className={styles.label}>
          <FormattedMessage id={`${prefix}-subtlety`} defaultMessage="Name"/>
        </div>
        <div className={styles.field}>
          <DataItemTextarea
            fieldId='invoiceOrderData.customerName'
            value={values.customerName}
            disabled={viewMode}
          />
        </div>
      </div>
      <div className={styles.generalDetailsItem}>
        <div className={styles.label}>
          <FormattedMessage id={`${prefix}-contact`} defaultMessage="Contact"/>
        </div>
        <div className={styles.field}>
          <DataItemTextarea
            fieldId='invoiceOrderData.contact'
            value={values.contact}
            disabled={viewMode}
          />
        </div>
      </div>
      <div className={styles.generalDetailsItem}>
        <div className={styles.label}>
          <FormattedMessage id={`${prefix}-dealNumber`} defaultMessage="Deal number"/>
        </div>
        <div className={classnames(styles.field, 'mb-2')}>
          <DataItem
            fieldId='invoiceOrderData.idNumber'
            value={values.idNumber}
            onChange={integerValue}
            disabled={viewMode}
          />
        </div>
      </div>
      <div className={styles.generalDetailsItem}>
        <div className={styles.label}>
          <FormattedMessage id={`${prefix}-phone`} defaultMessage="Phone"/>
        </div>
        <div className={styles.field}>
          <DataItemTextarea
            fieldId='invoiceOrderData.phone'
            value={values.phone}
            disabled={viewMode}
          />
        </div>
      </div>
      <div className={styles.generalDetailsItem}>
        <div className={styles.label}>
          <FormattedMessage id={`${prefix}-address`} defaultMessage="Address"/>
        </div>
        <div className={styles.field}>
          <DataItemTextarea
            fieldId='invoiceOrderData.address'
            value={values.address}
            disabled={viewMode}
          />
        </div>
      </div>
      <div className={styles.generalDetailsItem}>
        <div className={styles.label}>
          <FormattedMessage id={`${prefix}-email`} defaultMessage="Email recipients"/>
        </div>
        <div className={styles.field}>
          <DataItemTextarea
            fieldId='invoiceOrderData.emailRecipients'
            value={values.emailRecipients}
            disabled={viewMode}
          />
        </div>
      </div>
    </div>
  );
};

GeneralDetailsUnit.propTypes = {};

export default GeneralDetailsUnit;
